/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ReactNode } from "react";
import { Auth0Client } from "@auth0/auth0-spa-js";
import { useNavigate } from "react-router-dom";
import { Auth0Provider } from "./Auth0";
import { AppState } from "./types";

type Props = {
  client: Auth0Client;
  children: ReactNode;
};

export function Auth0ProviderWithHistory({ children, ...props }: Props) {
  const navigate = useNavigate();

  const onRedirectCallback = (appState: AppState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
}
